import type { StoreState, UiCoreQuestionFormState } from '../../state-types';

/** Update UI Core Question Form partially */
export const updateUiCoreQuestionForm =
    (partialUi: Partial<UiCoreQuestionFormState>) =>
    (state: StoreState): StoreState => ({
        ...state,
        uiCoreQuestionForm: {
            ...state.uiCoreQuestionForm,
            ...partialUi,
        },
    });
